import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import MapSection from "@/components/MapSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import SavingsCalculator from "@/components/SavingsCalculator";
import SolutionSection from "@/components/SolutionSection";
import ChallengeSection from "@/components/ChallengeSection";
import SegmentsSection from "@/components/SegmentsSection";
import Footer from "@/components/Footer";

const Index = () => {
  const { t, i18n } = useTranslation('home');
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <html lang={i18n.language?.startsWith('sv') ? 'sv' : 'en'} />
        <title>{t('meta.title')}</title>
        <meta name="description" content={t('meta.description')} />
        <link rel="canonical" href="https://cetasol.com" />
        <meta property="og:title" content={t('meta.title')} />
        <meta property="og:description" content={t('meta.ogDescription')} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://cetasol.com/" />
        <meta property="og:image" content="https://cetasol.com/og-image.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={t('meta.title')} />
        <meta name="twitter:description" content={t('meta.ogDescription')} />
        <meta name="twitter:image" content="https://cetasol.com/og-image.jpg" />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": "Cetasol",
          "url": "https://cetasol.com",
          "description": t('meta.description'),
          "publisher": { "@type": "Organization", "name": "Cetasol", "url": "https://cetasol.com" }
        })}</script>
      </Helmet>
      <a href="#main-content" className="skip-to-content">
        {t('skipToContent', { ns: 'common', defaultValue: 'Skip to main content' })}
      </a>
      <Header />
      <main id="main-content">
        <HeroSection />
        <div className="bg-surface-light">
          <MapSection />
          <TestimonialsSection />
        </div>
        <div className="container mx-auto px-6"><div className="border-t border-border" /></div>
        <ChallengeSection />
        <div className="container mx-auto px-6"><div className="border-t border-border" /></div>
        <SolutionSection />
        <div className="container mx-auto px-6"><div className="border-t border-border" /></div>
        <SavingsCalculator />
        <div className="container mx-auto px-6"><div className="border-t border-border" /></div>
        <SegmentsSection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
